import axios from "axios";
import * as ROUTES from "../../../constants/routes";
import Helpers from "../../Helpers";

export default class AddUserFunction {
  constructor() {
    this.helpers = new Helpers();
  }

  doEditUser = (userId, firstname, lastname, mobileNumber, ustatus) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          ROUTES.FUNCTIONAL_BASE_URL + "cms-admin/user/" + userId,
          JSON.stringify({
            lastName: lastname,
            firstName: firstname,
            mobileNumber: "+63" + mobileNumber,
            status: ustatus,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
